import type { ChangeEvent } from 'react';
import { useFormContext } from 'react-hook-form';
import { useRecordValueReader } from 'resources/rate_settings/utils/fieldsVisibility';
import { codeToField, RateCode } from './rateControllerModel';

export const useClearRateOnBlank = (code: RateCode, source: string) => {
  const { setValue } = useFormContext();
  const recordValue = useRecordValueReader();

  return (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target?.value) {
      setValue(codeToField(code, source, recordValue), null);
    }
  };
};
